import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './protected/styles.css';
import './theme/tokens.css';
import './ui/ui.css';
import App from './App';
import { installSessionGuard } from './session';

/* Installed before the first render so no request can slip past it. */
installSessionGuard();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);


